import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import UserSettingsForm from './UserSettingsForm';
import i18n from 'i18n';

interface UserSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeUserId: number;
}

const UserSettingsModal: React.FC<UserSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeUserId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_edit_user_settings.text')}
        entityId={activeUserId}
        entityIdPropName="userId"
        FormComponent={UserSettingsForm}
    />
));

export default UserSettingsModal; 